module.exports = __webpack_public_path__ + "img/yunIcu.6c80a98b.png";